/**
 * UTU group sites drop down menu
 */
var component_utu_sites_menu = function (args) {
  var menu = args.menu;

  // validate
  if (!menu) {
    console.log("Invalid UTU sites menu");
    return;
  }

  var menu_items = menu.querySelectorAll(".menu-item");
  var button = menu.querySelector(".utu-sites-menu__button");

  if (menu_items.length === 0) {
    console.log("Empty UTU sites menu");
    return;
  }

  var is_visible = function () {
    return menu.classList.contains("visible");
  };

  var show_menu = function () {
    menu.classList.add("visible");
    button.setAttribute("aria-expanded", true);
  };

  var hide_menu = function () {
    menu.classList.remove("visible");
    button.setAttribute("aria-expanded", false);
  };

  var handle_button_click = function () {
    button.addEventListener("click", function (e) {
      e.stopPropagation();
      if (is_visible()) { hide_menu(); } else { show_menu(); }
    });

    // hide menu if clicking elsewhere when menu is visible
    document.addEventListener("click", function () {
      if (is_visible()) { hide_menu(); }
    });
  };

  /**
   * Closes the menu when focus leaves the component
   */
  var close_on_focus_lost = function () {
    menu.addEventListener('focusout', function (e) {
      if (!menu.contains(e.relatedTarget)) {
        hide_menu();
      }
    });
  };

  /**
   * Init
   */
  var init_sites_menu = function () {
    handle_button_click();
    close_on_focus_lost();
  };

  init_sites_menu();

  // make the call chainable
  return this;
};
